module.exports = __webpack_public_path__ + "img/02_full.0a46f26d.jpg";